import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../shared/services/auth.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Firestore, doc, setDoc } from '@angular/fire/firestore';

@Component({
  selector: 'app-profile-completion',
  templateUrl: './profile-completion.component.html',
  styleUrls: ['./profile-completion.component.css'],
  standalone: false
})
export class ProfileCompletionComponent implements OnInit {
  profileForm!: FormGroup;
  loading = false;
  errorMessage: string | null = null;

  countries = [
    { code: 'US', name: 'United States' },
    { code: 'GB', name: 'United Kingdom' },
    { code: 'CA', name: 'Canada' },
    { code: 'AU', name: 'Australia' },
    { code: 'DE', name: 'Germany' },
    { code: 'FR', name: 'France' },
    { code: 'IT', name: 'Italy' },
    { code: 'ES', name: 'Spain' },
    { code: 'NL', name: 'Netherlands' },
    { code: 'BE', name: 'Belgium' },
    { code: 'CH', name: 'Switzerland' },
    { code: 'AT', name: 'Austria' },
    { code: 'SE', name: 'Sweden' },
    { code: 'NO', name: 'Norway' },
    { code: 'DK', name: 'Denmark' },
    { code: 'FI', name: 'Finland' },
    { code: 'PL', name: 'Poland' },
    { code: 'CZ', name: 'Czech Republic' },
    { code: 'JP', name: 'Japan' },
    { code: 'CN', name: 'China' },
    { code: 'IN', name: 'India' },
    { code: 'BR', name: 'Brazil' },
    { code: 'MX', name: 'Mexico' },
    { code: 'SG', name: 'Singapore' },
    { code: 'HK', name: 'Hong Kong' },
    { code: 'KR', name: 'South Korea' },
    { code: 'NZ', name: 'New Zealand' },
    { code: 'ZA', name: 'South Africa' },
    { code: 'RU', name: 'Russia' },
    { code: 'TR', name: 'Turkey' },
  ];

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private afs: Firestore,
    private dialogRef: MatDialogRef<ProfileCompletionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.initializeForm();
  }

  initializeForm(): void {
    const currentYear = new Date().getFullYear();
    const minYear = 1950;

    this.profileForm = this.fb.group({
      firstname: ['', [Validators.required, Validators.minLength(2)]],
      lastname: ['', [Validators.required, Validators.minLength(2)]],
      country: ['', Validators.required],
      university: ['', Validators.required],
      major: ['', Validators.required],
      graduationYear: ['', [
        Validators.required,
        Validators.pattern(/^\d{4}$/),
        Validators.min(minYear),
        Validators.max(currentYear + 10)
      ]],
      degreeLevel: ['', Validators.required],
    });

    this.countries.sort((a, b) => a.name.localeCompare(b.name));
  }

  async onSubmit(): Promise<void> {
    if (this.profileForm.invalid) {
      this.errorMessage = 'Please fill in all required fields correctly.';
      return;
    }

    this.loading = true;
    this.errorMessage = null;

    try {
      const user = this.authService.userData;
      if (!user?.email) {
        throw new Error('User email not found');
      }

      const userRef = doc(this.afs, `users/${user.email.toLowerCase()}`);
      await setDoc(userRef, this.profileForm.value, { merge: true });

      this.dialogRef.close(true);
    } catch (error: any) {
      console.error('Error saving profile:', error);
      this.errorMessage = 'Failed to save profile. Please try again.';
    } finally {
      this.loading = false;
    }
  }
}
